import { Component } from '@angular/core';
import { XpoConditionBase } from '../../../../validations/validations.class';
import { XpoFilterCondition } from '../../../condition';
import { filterFormats, Operators, OperatorText, XpoFilterConditionCriteria } from './../../../../../models/index';

@Component({ template: ' ' })
export class XpoConditionIsNotEmptyComponent extends XpoConditionBase implements XpoFilterCondition {
  static text = OperatorText.NotEmpty;
  static applyAlwaysEnabled: boolean = true;
  static operator = Operators.NotEmpty;

  isNegative = true;
  model: null = null;

  constructor() {
    super(filterFormats.default, false);
  }

  validate(cellValue): boolean {
    if (cellValue !== undefined) {
      return cellValue.toString().trim();
    }
    return false;
  }
  getCriteria(): XpoFilterConditionCriteria {
    return {
      operator: Operators.NotEmpty,
      value: '',
    };
  }
}
